import OutlinedInput from '@mui/material/OutlinedInput';
import { string } from 'prop-types';

/**
 * @component MenuHeaderInput
 * @param { Object } props
 * @param { string } props.value
 * @returns { JSX.Element }
 */
function MenuHeaderInput({ value }) {
	const style = {
		mui: { '& .MuiOutlinedInput-notchedOutline': { border: 'none' } },
		props: { fontSize: '0.85rem', fontWeight: 'bold', color: 'var(--cl-common-white)' },
	};

	return (
		<OutlinedInput
			sx={style.mui}
			value={value}
			readOnly={true}
			size="small"
			fullWidth
			inputProps={{ style: style.props }}
		/>
	);
}

MenuHeaderInput.propTypes = { value: string };

export default MenuHeaderInput;
